import React from 'react';
import _ from 'lodash';
import { Box, Card, CardContent, Stack, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { useParameterizedQuery } from 'react-fetching-library';

import { daysDifference, formatDate } from '../../../../../../../services/functions';

import { updateInvoiceNumberAction } from '../../../../../../../services/request';
import { SmallFormDateField } from '../../../../../../../components/small-fields/SmallFormDateField';

export const BottomBaseDataForm = props => {
  const { formik, manual, order, type } = props;
  const { query } = useParameterizedQuery(updateInvoiceNumberAction);
  const [dueDateDays, setDueDateDays] = React.useState(0);

  const updateInvoiceNumber = async issueDate => {
    const { payload, error, loading } = await query(!manual ? order.id : null, formik.values.type, issueDate);
    if (!error && !loading) {
      formik.setFieldValue('number', payload.number);
    };
  };

  const handleEditDueDateDays = val => {
    if (_.isInteger(val)) {
      setDueDateDays(val);
      const newDate = new Date(formik.values.sale_date);
      newDate.setDate(newDate.getDate() + val);
      formik.setFieldValue('due_date', formatDate(newDate));
    } else {
      setDueDateDays(0);
    }
  };

  const handleDueDateChange = val => {
    formik.setFieldValue('due_date', formatDate(val));
    setDueDateDays(daysDifference(formatDate(val), formik.values.sale_date));
  };

  return (
    <Card sx={{ marginTop: '20px' }}>
      <CardContent>
        <Stack sx={{ marginBottom: '20px' }} direction="row" spacing={2}>
          <SmallFormDateField
            standardTextField
            name="issue_date"
            id="issue_date"
            type="text"
            label="Data wystawienia"
            placeholder="data wystawienia"
            value={formik.values.issue_date}
            onChange={val => {
              formik.setFieldValue('issue_date', formatDate(val));
              updateInvoiceNumber(formatDate(val));
            }}
            error={Boolean(formik.errors.issue_date)}
            helperText={formik.touched.issue_date && formik.errors.issue_date}
            sx={{ width: null, maxWidth: null }}
          />
          <FormControl>
            <InputLabel id="payment_method-label">sposób płatności</InputLabel>
            <Select
              id="payment_method"
              name="payment_method"
              labelId="payment_method-label"
              value={formik.values.payment_method}
              label="sposób płatności"
              onChange={formik.handleChange}
            >
              <MenuItem value="gotowka">Gotówka</MenuItem>
              <MenuItem value="przelew">Przelew</MenuItem>
              <MenuItem value="przedplata">Przedpłata</MenuItem>
              <MenuItem value="karta_platnicza">Karta płatnicza</MenuItem>
            </Select>
          </FormControl>
        </Stack>
        {[1, 2, 3].includes(type)
          ? <Stack sx={{ marginBottom: '20px' }} direction="row" spacing={2}>
            <SmallFormDateField
              standardTextField
              name="due_date"
              id="due_date"
              type="text"
              label="Termin płatności"
              placeholder="termin płatności"
              value={formik.values.due_date}
              onChange={val => handleDueDateChange(val)}
              error={Boolean(formik.errors.due_date)}
              helperText={formik.touched.due_date && formik.errors.due_date}
              sx={{ width: null, maxWidth: null }}
            />
            <FormControl>
              <TextField sx={{ width: 130 }} value={dueDateDays} onChange={e => handleEditDueDateDays(parseInt(e.target.value))} />
            </FormControl>
          </Stack> : null }
        <TextField
          id="remarks"
          multiline
          fullWidth
          rows={4}
          label="Uwagi"
          value={formik.values.remarks}
          onChange={formik.handleChange}
        />
        <Box height={20} />
        { [2, 6].includes(type)
          ? <TextField
            id="correction_reason"
            multiline
            fullWidth
            rows={4}
            label="Przyczyna korekty"
            value={formik.values.correction_reason}
            onChange={formik.handleChange}
          /> : null}
      </CardContent>
    </Card>
  );
};
